import {
	createResource,
	type RouterContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import type { ProjectConfiguration } from './ProjectConfiguration.types.tsx';

export const CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG =
	'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';

const getKey = ({ match }: RouterContext): string =>
	typeof match.params.projectKey === 'string' ? match.params.projectKey : '';

export const changeManagementSettingsProjectConfigurationResource: RouteResource<ProjectConfiguration> =
	createResource<ProjectConfiguration>({
		type: CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG,
		getKey,
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-change-management-project-configuration", jiraSpaEntry: "async-resource-change-management-project-configuration" */ './getProjectConfigurationData.tsx'
			),
		maxAge: Infinity,
	});
